export function register() {
    // Only register in production — in dev mode, service-worker.js doesn't exist
    // and causes a MIME type error (HTML 404 returned instead of JS).
    if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then(registration => {
          console.log('ServiceWorker registered: ', registration);
        }).catch(error => {
          console.log('ServiceWorker registration failed: ', error);
        });
      });
    }
  }